import React from 'react'
import PropTypes from 'prop-types';
import qs from 'qs'
import {
	Table,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableBody,
	TableRowColumn
} from 'material-ui/Table'
import AcquireWebComponent from '../framework/MaterialUI';
import RaisedButton from 'material-ui/RaisedButton';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ArrowUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import InviteUser from './InviteUser';
import UpdateAdminUserTip from './UpdateAdminUserTip';
import Page from '../framework/Page/Page';
import {isEmpty} from 'lodash'
// confirmation
import { buttonBlueColor } from "../../utils/utility";

import moment from 'moment'
import './ClientUsers.css'
const styles = {
	tableHeaderStyle: {
    borderTop: '1px solid #000',
    borderBottom: '1px solid #000',
    background: '#E4E4E4'
	},
	arrowStyle: {
		position: 'absolute',
		top: '1px'
	},
	tableHeaderColumn: {
		height: '30px',
		color: '#000',
		cursor: 'pointer',
		fontWeight: 'bolder',
    paddingLeft: '10px'
	},
	tableHeaderSortedColumn: {
		height: '30px',
		color: '#000',
		cursor: 'pointer',
		fontWeight: 'bolder',
    background: "#CECECE",
    paddingLeft:'10px',
    backgroundClip: 'padding-box'
	},
	tableRowColumn: {
    position: 'relative',
    paddingLeft: '10px',
    height:'30px'
	},
	settingStyle: {
		position: 'absolute',
		right: '6em',
		top: '0.9em',
		cursor: 'pointer'
	}
}

class ClientUsers extends AcquireWebComponent {
	constructor(props) {
		super(props);
		this.throttle = true;
		this.state = {
			open: false,
			value: '', // for table list dialog role value
			rolesValue: '', // role value for invite component
			openInviteUser: false,
			requestParams: {
				pageNumber: 1,
				pageSize: 10,
				sortColumn: 'name', //support name , role, email, status field
				order: 'desc' // asc or desc
			},
			employeeName: '', // name of employee
			suspendUserDialogOpen: false, // if open the dialog of suspend user success ui
			ifReassignClientUIDispaly: false, // weather display re-assign client.
			ifDisplayConfirmation: false,
			ifDisplayUpdateAdminUser: true, // default display update admin user view
			archiveUserDialogOpen: false, // open the dialog, when click `Archive User`
			ifArchiveOverlayDisplay: false,  // archive overlay
			ifDisplayArchiveUserLink: false, // if archive link click
			updateParams: {
				firstName: '',
				lastName: '',
				email: '',
				roleId: 1
			},
			employeeId: '',
			ifUpdateButtonDisable: true
		}
	}
	componentDidMount() {
		if (this.props.roleId === 5)//operation manager
			this.props.history.push("/")
		// get role data
		const params = {
			pageNumber: 1,
			pageSize: 10,
			sortColumn: 'name', //support name , role, email, status field
			order: 'desc' // asc or desc
		}
		// administartor or team member
		if (this.props.roleId > 50) {
			if (this.props.getClientRoles) {
        this.props.getClientRoles()
      }
      if (/^\/clients\/edit\/Client-Team-Members/.test(this.props.location.pathname) && (/administrator|team member/gi.test(this.props.roleName))) {
        this.props.getTableList(this.props.clientId, this.props.match.params.id);
      } else {
        this.props.getTableList(params, this.props.clientId);
      }
		}
		else if (this.props.roleId > 0) {
			this.props.getRoles()
      if (/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname)) {
			  this.props.getTableList(this.props.match.id)
      } else if (/^\/clents\/edit\/Client-Team-Members/.test(this.props.location.pathname) && (/administrator|team member/gi.test(this.props.roleName))) {
			  this.props.getTableList(this.props.clientId, this.props.match.params.id);
      } else {
        if (this.props.clientId)
          this.props.getTableList(params, this.props.clientId);
        else
          this.props.getTableList(params)
      }

		}

	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.roleId === 5)
			this.props.history.push("/")
		if (nextProps.updateErrorText === '') {
			this.setState({
				open: false
			})
		}
		const params = {
			pageNumber: 1,
			pageSize: 10,
			sortColumn: 'name', //support name , role, email, status fieldf
			order: 'desc' // asc or desc
		}
		if (nextProps.roleId !== this.props.roleId) {
			if (nextProps.roleId > 50) {
				if (nextProps.getClientRoles)
					nextProps.getClientRoles()
				if (nextProps.selected_client > 0)
          if (/^\/clients\/edit\/Client-Team-Members/.test(nextProps.location.pathname) && (/administrator|team member/gi.test(nextProps.roleName))) {
            nextProps.getTableList(nextProps.clientId, nextProps.match.params.id);
          } else {
            nextProps.getTableList(params, nextProps.selected_client);
          }
			}
			else if (nextProps.roleId > 0) {
				nextProps.getRoles()
        if (/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(nextProps.location.pathname)) {
          nextProps.getTableList(nextProps.match.params.id, qs.parse(nextProps.location.search).id)
        } else {
          if (nextProps.clientId)
            nextProps.getTableList(params, nextProps.clientId);
          else
            nextProps.getTableList(params)
        }
			}
		}

		if (nextProps.selected_client !== this.props.selected_client) {
			if (nextProps.roleId > 50) {
				if (nextProps.selected_client > 0)
					this.props.getTableList(params, nextProps.selected_client);
			} else if (nextProps.roleId > 0) {
				this.props.getTableList(params)
			}
		}
	}
	dispatchPageAction(page) {
		this.setState({
			requestParams: {
				...this.state.requestParams,
				pageNumber: page
			}
		})
		const params = {
			pageNumber: page,
			pageSize: this.state.requestParams.pageSize,
			sortColumn: this.state.requestParams.sortColumn, //support name , role, email, status field
			order: this.state.requestParams.order// asc or desc
		}
		if (this.props.selected_client && this.props.roleId > 50)
			this.props.getTableList(params, this.props.selected_client)
		else {
      if (!this.props.clientId) {
        this.props.getTableList(params)
      } else {
        this.props.getTableList(params, this.props.clientId)
      }
    }
	}
	//call back for page component
	nextBeClick(page) {
		this.dispatchPageAction(page);
	}
	nextGroupBeClick(page) {
		this.dispatchPageAction(page)
	}
	previousGroupBeClick(page) {
		this.dispatchPageAction(page)
	}
	previousBeClick(page) {
		this.dispatchPageAction(page)
	}
	pageBeClick(page) {
		this.dispatchPageAction(page)
	}
	goToPage(page) {
		if (page > this.props.tableList.pageCount) {
			return;
		} else {
			this.dispatchPageAction(page);
		}
	}
	selectRows (page, row) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        pageSize: row
      }
    }, () => {
      this.dispatchPageAction(page);
    })
  }
	//end
	handleDialogShow(e, employeeName) {
		let url = `/employees/user-status/${employeeName.id}/${this.state.requestParams.pageNumber}/${this.state.requestParams.sortColumn}/${this.state.requestParams.order}`
		if (this.props.clientId) {
      // set localStorage
      localStorage.setItem('clientTeamMemberName', `${employeeName.firstName} ${employeeName.lastName}`);
      if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
        url = `/clients/edit/Client-Team-Members/user-status/${employeeName.id}/${this.state.requestParams.pageNumber}/${this.state.requestParams.sortColumn}/${this.state.requestParams.order}?cid=${this.props.clientId}`
      } else if (/^(administrator|team member)/gi.test(this.props.roleName)) {
        url = `/clients/edit/Client-Team-Members/user-status/${employeeName.id}/${this.state.requestParams.pageNumber}/${this.state.requestParams.sortColumn}/${this.state.requestParams.order}?cid=${this.props.clientId}&name=${qs.parse(this.props.location.search.split('?')[1]).name}`
      }

    }
    if (this.props.suspendOrReactivate) {
		  let query = qs.stringify({
        name: `${employeeName.firstName} ${employeeName.lastName}`,
        id: qs.parse(this.props.location.search.split('?')[1]).id
      });
		  let businessUnitName = qs.parse(this.props.location.search.split('?')[1]).name
		  url = `/clients/edit/Business-Units/detail/Business Unit Team Members/${this.props.match.params.id}?cid=${employeeName.id}&${query}&businessUnitName=${businessUnitName}`;
    }
    this.props.history.push(url)
	}
  closeDialog() {
    this.setState({
      open: false,
      suspendUserDialogOpen: false, // if open the dialog of suspend user success ui
      ifReassignClientUIDispaly: false, // weather display re-assign client.
      ifDisplayConfirmation: false,
      ifDisplayUpdateAdminUser: true, // default display update admin user view
      archiveUserDialogOpen: false, // open the dialog, when click `Archive User`
      ifArchiveOverlayDisplay: false,  // archive overlay
      ifDisplayArchiveUserLink: false // if archive link click
    })
  }
  handleItemsChange(e, index, value) {
    this.setState({
      value,
      updateParams: {
        ...this.state.updateParams,
        roleId: value
      }
    })
  }
  handleInviteUser() {
    this.setState({
      openInviteUser: true
    })
  }
  closeInviteDialog() {
    this.setState({
      openInviteUser: false,
      suspendUserDialogOpen: false, // if open the dialog of suspend user success ui
      ifReassignClientUIDispaly: false, // weather display re-assign client.
      ifDisplayConfirmation: false,
      ifDisplayUpdateAdminUser: true, // default display update admin user view
      archiveUserDialogOpen: false, // open the dialog, when click `Archive User`
      ifArchiveOverlayDisplay: false,  // archive overlay
      ifDisplayArchiveUserLink: false // if archive link click
    })
  }
  saveUpdate() {
    this.props.updateProfile(this.state.employeeId, this.state.updateParams);
  }
  clickSuspendUser() {
    this.setState({
      suspendUserDialogOpen: true,
      employeeName: this.state.employeeName
    })
  }
  closeSuspendUserDialog() {
    this.setState({
      suspendUserDialogOpen: false
    })
  }
  continueSuspendUser() {
    this.setState({
      ifReassignClientUIDispaly: true,
      ifDisplayUpdateAdminUser: false
    });
  }
  goBackFromRessignClientUI() {
    this.setState({
      ifReassignClientUIDispaly: false,
      ifDisplayUpdateAdminUser: true
    });
  }
  displayConfirmation() {
    // when confirmation display, reassign view should been hide
    this.setState({
      ifDisplayConfirmation: true,
      ifReassignClientUIDispaly: false,
      ifDisplayUpdateAdminUser: false // hide update admin user view
    })
  }
  closeConfirmation() {
    // when click the `close` button of confirmation, init state
    this.setState({
      suspendUserDialogOpen: false,
      ifReassignClientUIDispaly: false,
      ifDisplayConfirmation: false,
      ifDisplayUpdateAdminUser: true,
      open: false
    })
  }
  clickArchiveUser() {
    this.setState({
      archiveUserDialogOpen: true
    })
  }
  closeArchiveUserTipDialog() {
    this.setState({
      archiveUserDialogOpen: false
    })
  }
  // archive user overlay display function
  continueArchiveUser() {
    // display archive overlay
    this.setState({
      ifArchiveOverlayDisplay: true,
      ifDisplayUpdateAdminUser: false // hide update admin user overlay
    })
  }
  closeArchiveUserDialog() {
    this.setState({
      suspendUserDialogOpen: false, // if open the dialog of suspend user success ui
      ifReassignClientUIDispaly: false, // weather display re-assign client.
      ifDisplayConfirmation: false,
      ifDisplayUpdateAdminUser: true, // default display update admin user view
      archiveUserDialogOpen: false, // open the dialog, when click `Archive User`
      ifArchiveOverlayDisplay: false  // archive overlay
    })
  }
  archiveUserLink() {
    this.setState({
      ifDisplayArchiveUserLink: true
    })
  }
  clearArchiveLink() {
    this.setState({
      ifDisplayArchiveUserLink: false // roll back to archive link
    })
  }
  // role item change function
  handleRoleItemsChange(value) {
    this.setState({
      rolesValue: value.value
    })
  }
  handleHeaderClick (e) {
    this.setState({
      cache_sortColumn: e.target.innerText
    })
    const params = {
      order: (this.state.requestParams.order === 'desc' && this.state.cache_sortColumn === e.target.innerText) ? 'asc' : 'desc',
      sortColumn: 'name'
    }
    switch(e.target.innerText){
      case 'Role':
        params.sortColumn = 'role';
        break
      case 'Email':
        params.sortColumn = 'email';
        break
      case 'Status':
        params.sortColumn = 'status';
        break;
      case 'Name':
        params.sortColumn = 'name';
        break;
      case 'Last Logged on':
        params.sortColumn = 'lastLoggedonDatetime';
        break;
      default:
        return ;
    }
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        order: params.order,
        sortColumn: params.sortColumn
      }
    }, () => {
      if (/^system administrator/gi.test(this.props.roleName)) {
        this.props.getTableList(this.state.requestParams, this.props.clientId);
      } else {
        this.props.roleId > 50 ? this.props.getTableList(this.state.requestParams, this.props.selected_client) : this.props.getTableList(this.state.requestParams)
      }
    })
  }
  handleFirstName (e) {
    this.checkButtonEnable();
    this.setState({
      updateParams: {
        ...this.state.updateParams,
        firstName: e.target.value,
      }
    })
  }
  handleLastName (e) {
    this.checkButtonEnable();
    this.setState({
      updateParams: {
        ...this.state.updateParams,
        lastName: e.target.value
      }
    })
  }
  handleEmail (e) {
    this.checkButtonEnable();
    this.setState({
      updateParams: {
        ...this.state.updateParams,
        email: e.target.value
      }
    })
  }
  checkButtonEnable () {
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (
      /^([A-z]{1,}\s?)*[A-z]$/g.test(this.refs.firstName.value) &&
      /^[A-z]+(-{0,1}[A-z])+$/g.test(this.refs.lastName.value) &&
      re.test(this.refs.email.value)
    ) {
      this.setState({
        ifUpdateButtonDisable: false
      })
    } else {
      this.setState({
        ifUpdateButtonDisable: true
      })
    }
  }
  closeUpdateSuccessTip () {
    // init button to disable and request param and employeeId
    this.setState({
      ifUpdateButtonDisable: false,
      updateParams: {
        firstName: '',
        lastName: '',
        email: '',
        roleId: 1
      },
      employeeId: ''
    })
    this.props.rollBackUpdateStatus();
    // refresh table list
    // this.props.getTableList({
    //   pageNumber: this.state.pageNumber,
    //   pageSize: 10,
    //   sortColumn: 'name', //support name , role, email, status field
    //   order: 'desc' // asc or desc
    // });
    this.dispatchPageAction(this.state.requestParams.pageNumber);
  }

	handleIconClick(targetName) {
		const params = {
			order: this.state.requestParams.order === 'desc' ? 'asc' : 'desc',
			sortColumn: 'name'
		}

		switch (targetName) {
			case 'Role':
				params.sortColumn = 'role';
				break
			case 'Email':
				params.sortColumn = 'email';
				break
			case 'Status':
				params.sortColumn = 'status';
				break;
			case 'Name':
				params.sortColumn = 'name';
				break;
      case 'Last Logged on':
        params.sortColumn = 'lastLoggedonDatetime';
        break;
			default:
				return;
		}
		this.setState({
			requestParams: {
				order: params.order,
				sortColumn: params.sortColumn
			}
		}, () => {
      if (/^system administrator/gi.test(this.props.roleName)) {
        this.props.getTableList(this.state.requestParams, this.props.clientId);
      } else {
        this.props.roleId > 50 ? this.props.getTableList(this.state.requestParams, this.props.selected_client) : this.props.getTableList(this.state.requestParams)
      }
    })
	}

	getTableColWidth(index){
		switch(index){
      case 1:
        return '23%';
			case 2:
				return '30%';
			case 3:
				return '15%';
			default:
				return 'auto';
		}
	}
	filterSuccessReduceProp () {
    if (
      /^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) &&
      /^(system administrator|account manager)/gi.test(this.props.roleName)
    ) {
      return this.props.ifSendInviteSuccess;
    } else if (
      /^(\/clients\/edit\/Business-Units\/detail\/Team Members)/g.test(this.props.location.pathname) &&
      /^(system administrator|account manager)/gi.test(this.props.roleName)
    ) {
      return this.props.ifInviteBusinessUnitMemberSuccess;
    } else if (
      /^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) &&
      /^(administrator|team member)/gi.test(this.props.roleName)
    ) {
      return this.props.ifInviteBusinessUnitMemberSuccess;
    } else {
      return this.props.ifSendInviteSuccess;
    }
  }
	render() {
		const inviteUserRoles = isEmpty(this.props.match.params.id) ? this.props.roles : [{value:51, label:'Administrator'}]
		const clientAdminMode = (!isEmpty(this.props.match.params.id)) && (this.props.roleId < 50)
		return (
			<div className="wrapper" style={{ paddingLeft: '2%', paddingRight: '2%' }} onClick={(e) => this.handleHeaderClick(e)}>
        {
          /^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname) && (
            <div className="disabled-sort-container" style={{background: 'none', zIndex: '1000', height: '36px', position: 'absolute', width: '80%', left: '10%', padding: '0 10%'}}>
            </div>
          )
        }
				<Table style={{ fontFamily: 'Arial'}}
				>
					<TableHeader
						displaySelectAll={false}
						style={styles.tableHeaderStyle}
						adjustForCheckbox={false}
					>
						<TableRow
							displayBorder={false}
							style={{ height: '30px' }}
						>

							{[{ name: 'Name', value: 'name' }, { name: 'Role', value: 'role' },
								{ name: 'Email', value: 'email' }, { name: 'Status', value: 'status' },
								{ name: 'Last Logged on', value: 'lastLoggedonDatetime'}].map((item, index) => (
								  // if url is /clients/edit/Business-Units/detail/Team Member will not show background
								<TableHeaderColumn
									style={{ ...this.state.requestParams.sortColumn === item.value ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, textAlign: index === 3 ? 'left' : '', width: this.getTableColWidth(index)}}
									key={index}
								>
									{item.name}
									{/*when /client/edi/business-units/detail/team member*/}
                  {
                    !/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname) && (
                      <ArrowDown onClick={() => this.handleIconClick(item.name)} style={{ display: this.state.requestParams.order === 'desc' && this.state.requestParams.sortColumn === item.value ? 'inline-block' : 'none', position: 'absolute', top: '0', right: '0' }} />
                    )
                  }
                  {
                    !/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname) && (
                      <ArrowUp onClick={() => this.handleIconClick(item.name)} style={{ display: this.state.requestParams.order === 'asc' && this.state.requestParams.sortColumn === item.value ? 'inline-block' : 'none', position: 'absolute', top: '0', right: '0' }} />
                    )
                  }

								</TableHeaderColumn>
							))}
							{/*<TableHeaderColumn style={{height: '35px'}}></TableHeaderColumn>*/}
						</TableRow>
					</TableHeader>
					<TableBody
						displayRowCheckbox={false}
					>
            {
              /^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname) &&
              isEmpty(this.props.tableList) && (
                <TableRow
                  style={{border: 'none'}}
                >
                  <TableRowColumn>
                    <p style={{marginTop: '3em', textAlign: 'center', fontSize: '16px', fontWeight: 'bolder'}}>No Business Unit Team Member exist for this Business Unit</p>
                  </TableRowColumn>
                </TableRow>
              )
            }
						{(!isEmpty(this.props.tableList)) &&
							this.props.tableList.map((item, index) => (
							<TableRow
								selectable={false}
								key={item.id}
								style={{ borderBottom: '1px solid black', height:'30px' }}
							>
								<TableRowColumn style={{ ...styles.tableRowColumn, color: '#0997F7', cursor: 'pointer' }}>
									<span onClick={(e) => this.handleDialogShow(e, item)}>{`${item.firstName} ${item.lastName}`}</span>
								</TableRowColumn>
								<TableRowColumn style={{...styles.tableRowColumn, width: '23%'}}>
									{item.role.name}
								</TableRowColumn>
								<TableRowColumn style={{...styles.tableRowColumn, width: this.getTableColWidth(2)}}>
									{item.email}
								</TableRowColumn>
								<TableRowColumn style={{ ...styles.tableRowColumn, textAlign: 'left', width: this.getTableColWidth(3) }}>
									{item.status}
								</TableRowColumn>
								<TableRowColumn style={styles.tableRowColumn}>
									{item.lastLoggedonDatetime ? moment.unix(item.lastLoggedonDatetime/1000).format('M/D/YY') : ''}
								</TableRowColumn>
							</TableRow>
						))}
					</TableBody>
				</Table>
				<div className="page-btn">
					<Page
						nextBeClick={(page) => this.nextBeClick(page)}
						pageCount={this.props.origin_tableList ? this.props.origin_tableList.pageCount : 0}
						pageSize={this.props.origin_tableList ? this.props.origin_tableList.pageSize : 10}
						nextGroupBeClick={(page) => this.nextGroupBeClick(page)}
						previousGroupBeClick={(page) => this.previousGroupBeClick(page)}
						previousBeClick={(page) => this.previousBeClick(page)}
						pageBeClick={(page) => this.pageBeClick(page)}
						total={this.props.origin_tableList ? this.props.origin_tableList.total : 0}
						hasNext={this.props.origin_tableList ? this.props.origin_tableList.hasNext : false}
						hasPrevious={this.props.origin_tableList ? this.props.origin_tableList.hasPrevious : false}
						selectRows={(page, row) => this.selectRows(page, row)}
						goToPage={(page) => this.goToPage(page)}
						pagePlus={true}
            style={{marginTop: '20px'}}
					/>
					{
					  (
              clientAdminMode ||
              (this.props.roleId <= 51) ||
              (
                /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname) &&
                /^(administrator|team member)/gi.test(this.props.roleName)
              )
            ) && (
					<RaisedButton
						label={/^(administrator|team member)/gi.test(this.props.roleName) || /^\/clients\/edit\/Business-Units\/detail\/Team Members/g.test(this.props.location.pathname) ? "Invite Business Unit Team Member" : "Invite Team Member"}
						backgroundColor={buttonBlueColor()}
						labelStyle={{ color: 'white', padding: '0 6px', fontSize: '16px'}}
						style={{ position: 'absolute', top: 0, width: 'auto', height: '46px', lineHeight: '30px'}}
						onClick={() => this.handleInviteUser()}
					/>)}
				</div>
				          {/*the dialog of invite user button be clicked*/}
					<InviteUser
            openInviteUser={this.state.openInviteUser}
						closeInviteDialog={() => this.closeInviteDialog()}
            roles={inviteUserRoles}
						rolesValue={ clientAdminMode ? 51 : this.state.rolesValue}
            roleName={this.props.roleName}
						clientId={clientAdminMode ? this.props.match.params.id : null}
            handleItemsChange={(value) => this.handleRoleItemsChange(value)}
            // if router is /employees use this.props.sendInvite /edit/Business-Unit/Team Member user this.props.sendInviteBusinessUnitMember
            sendInvite={(this.props.roleId > 50 ) ?
              /^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) ? this.props.sendInviteBusinessUnitMember : this.props.sendClientInvite  :
              /^(\/clients\/edit\/Business-Units\/detail\/Team Member)/g.test(this.props.location.pathname) ?
              this.props.sendInviteBusinessUnitMember :
              this.props.sendInvite
            }
            ifSendInviteSuccess={this.filterSuccessReduceProp()}
            match={this.props.match}
            rollbackStatus={
              (
                /^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname) ||
                /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname)
              )?
              this.props.rollbackStatus :
              this.props.rollBackStatus
            }
            sendInvite_error_message={ this.props.sendInvite_error_message}
            send_invitation_error_msg={this.props.send_invitation_error_msg}
            location={this.props.location}
          />
          {/*suspend user tip*/}
          <UpdateAdminUserTip
            UpdateAdminUserTipDialogOpen={this.state.suspendUserDialogOpen}
            closeUpdateAdminUserTipDialog={() => this.closeSuspendUserDialog()}
            continue={() => this.continueSuspendUser()}
            continueLabel="Yes, continue"
          >
            <p className="suspend-user-tips">
              Are you sure you want to suspend <br />
              [{`${this.state.employeeName.firstName} ${this.state.employeeName.lastName}`}]?
            </p>
          </UpdateAdminUserTip>

          {/*archive user tip*/}
          <UpdateAdminUserTip
            UpdateAdminUserTipDialogOpen={this.state.archiveUserDialogOpen}
            closeUpdateAdminUserTipDialog={() => this.closeArchiveUserTipDialog()}
            continue={() => this.continueArchiveUser()}
            continueLabel="Yes, continue"
          >
            <p className="suspend-user-tips">
              Are you sure you want to archive <br />
              [{`${this.state.employeeName.firstName} ${this.state.employeeName.lastName}`}]?
            </p>
          </UpdateAdminUserTip>
			</div>
		)
	}
}

ClientUsers.propTypes = {
  selected_client: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	roleId: PropTypes.number,
	getTableList: PropTypes.func.isRequired,
	getClientRoles: PropTypes.func,
	roles: PropTypes.array,
	sendInvite: PropTypes.func,
	sendClientInvite: PropTypes.func,
	sendInvite_error_message: PropTypes.string,
	rollBackStatus: PropTypes.func,
	inviteBusinessMember: PropTypes.func
}
export default ClientUsers


// WEBPACK FOOTER //
// ./src/components/Employees/ClientUsers.jsx